module.exports = __webpack_public_path__ + "img/sage.8b8dbfd8.svg";